module.exports = __webpack_public_path__ + "img/established.9df39e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/established.png
// module id = 1806
// module chunks = 1